import { DiscoveryApi, FetchApi } from '@backstage/frontend-plugin-api';
import { Account } from '@internal/backstage-plugin-catalog-devops-common';
import {
  DefaultApiClient,
  DefaultApiResponse,
} from '@internal/backstage-plugin-devops-react';
import { AccountApi } from './AccountApi';

export class AccountApiClient extends DefaultApiClient implements AccountApi {
  public constructor(options: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
  }) {
    super({
      backendName: 'catalog',
      ...options,
    });
  }

  async getUsers(groupRef?: string): Promise<DefaultApiResponse> {
    const urlSegment = groupRef
      ? `/v2/users?group=${encodeURIComponent(groupRef)}`
      : '/v2/users';
    return await this.get(urlSegment);
  }

  async createAccountEntity(data: Account): Promise<DefaultApiResponse> {
    const urlSegment = '/v2/account';
    return await this.post<Account>(urlSegment, data);
  }

  async editAccountEntity(
    id: string,
    data: Account,
  ): Promise<DefaultApiResponse> {
    const urlSegment = `/v2/account/${id}`;
    return await this.put<Account>(urlSegment, data);
  }

  async deleteAccountEntity(id: string): Promise<DefaultApiResponse> {
    const urlSegment = `/v2/account/${id}`;
    return await this.delete(urlSegment);
  }
}
